import * as React from 'react';
import { Route, Switch } from 'react-router-dom';

const renderRoutes = (routes) => {
	const flatRoutes = flattenArray(routes.map(r => flatten(r)));
	return (
		<Switch>
			{
				flatRoutes.map((route, i) => route.path ?
					<Route key={i} path={route.path} exact={true} render={props => renderComponent(route, props)} />
					: <Route key={i} render={props => renderComponent(route, props)} />)
			}
		</Switch>
	)
};

function renderComponent(route, props) {
	let componentType = {
		component: route.components.shift()
	};
	let component = <componentType.component {...props} />;

	route.components.forEach(c => {
		componentType.component = c;
		component = <componentType.component {...props} children={component} />
	})

	return component;
}

function flatten(route, parentRoute) {
	if (parentRoute === undefined) {
		parentRoute = {
			components: [],
			path: ''
		};
	}

	let newRoute = {
		...route,
		components: parentRoute.components.slice()
	}

	if (newRoute.path !== undefined && parentRoute.path !== undefined) {
		let parentPath = parentRoute.path;
		if (parentPath.length > 0 && parentPath[parentPath.length - 1] !== '/') parentPath += '/';

		newRoute.path = parentPath + newRoute.path
	} else {
		newRoute.path = '';
	}
	newRoute.components.unshift(route.component);

	var subRoutes = route.routes ? [...route.routes] : [];
	if (route.index) {
		subRoutes.unshift({ ...route.index, path: '' });
	}

	if (subRoutes.length > 0) {
		return flattenArray(subRoutes.map(childRoute => flatten(childRoute, newRoute)));
	} else {
		return newRoute;
	}
}

function flattenArray(arr) {
	return [].concat.apply([], arr);
}

export { renderRoutes };



// WEBPACK FOOTER //
// ./src/routing/renderRoutes.js